import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import ls from "util/secureStorage";
import constant from "config/constant";
import { wrapBaseApi } from "util/apiWrapper";

// console.log("AUTH HEADER", _headers);

// Define a service using a base URL and expected endpoints
export const chartApi = createApi({
  reducerPath: "chart",
  // refetchOnReconnect: true,
  refetchOnMountOrArgChange: true,
  tagTypes: ["prices"],
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_WALLET_API_ENDPOINT}`,
    prepareHeaders: (headers, _) => {
      const auth = ls.get(constant.AUTH_TOKEN_KEY);

      headers.set("Authorization", auth.token);
      headers.set("Content-Type", "application/json");
      headers.set("Cache-Control", "no-cache, no-store, must-revalidate");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getPriceData: builder.query({
      query: ({
        coin = "bitcoin",
        days = "30",
        hours = "24",
        interval = "daily",
      }) =>
      wrapBaseApi(`${process.env.REACT_APP_API_ENDPOINT}/market/charts/prices?base=usd&coin=${coin}&days=${days}&hours=${hours}&interval=${interval}`),

      transformResponse: (res) => {
        const data = res?.data;
        return { prices: data?.marketChart?.prices };
      },
      // providesTags: ["rate"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetPriceDataQuery } = chartApi;

export default chartApi;
